import Icon from "../../atom/Icon";
import styles from './IconList.module.scss'

export default function IconList(props) {

  const icons = props.icons

  return (
    <div className={styles.IconList}>
      { icons &&
        icons.map((icon) => (
          <Icon key={icon.title}
                title={icon.title}
                description={icon.description}
                link={icon.link}
                imgUrl={icon.imgUrl}
                externalLink={icon.externalLink}
          />
        ))
      }
    </div>
  );
}